"use strict";
import { Validate } from "../validate";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var contact = function () {

    var contactQuestion = $('.contact-question');

    if (contactQuestion.length > 0) {

        var sendBtn = $('#sendQuestion'),
            closeModalBtn = $('#close'),
            responseWrap = contactQuestion.find('.response-wrapper'),
            cl = new CanvasLoader('loader'),
            invalidMessage = sendBtn.attr('data-invalid-message'),
            successMessage = sendBtn.attr('data-success-message'),
            successWrap = contactQuestion.find('.success-wrapper'),
            select = contactQuestion.find('select'),
            textarea = contactQuestion.find('textarea');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        sendBtn.on('click', sendQuestion);
        closeModalBtn.on('click', closeModal);
    }

    function sendQuestion(e) {

        e.preventDefault();

        var selectValue = select.val(),
            textareaValue = textarea.val(),
            data = {},
            request = {},
            inputs = contactQuestion.find('.form-item input, .form-item textarea'),
            validated = true;

        inputs.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
            }
        });

        if (selectValue != null && selectValue != "" && validated) {

            cl.show();
            sendBtn.addClass('loading');
            responseWrap.hide();

            request['message'] = textareaValue;
            request.additionalfields = new Array();
            contactQuestion.find('.form-item input[name]').each(function () {
                var $this = $(this),
					prop = $this.attr('name'),
					value = $this.val();
                request.additionalfields.push({ Name: prop, Value: value });
            });
            request['pageid'] = SETTINGS.pageid;
            request['language'] = SETTINGS.language;
            request['contactformid'] = $("#hfFormID", form).val();
            data['request'] = request;

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.sendQuestion,
                data: JSON.stringify(data)
            });


            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }
        else {
            responseWrap.html(invalidMessage).show();
        }

    }

    function doneHandler(response) {

        cl.hide();
        sendBtn.removeClass('loading');

        if (response.Success) {
            responseWrap.hide();
            successWrap.removeClass('hidden').find('p').html(successMessage);
            select.prop('selectedIndex', 0);
            select.trigger("liszt:updated");
            textarea.val('');
        }
        else {
            displayGenericError(responseWrap, response);
            cl.hide();
            sendBtn.removeClass('loading');            
        }


    }

    function failHandler(response) {
        serviceNetworkError(responseWrap);
        cl.hide();
        sendBtn.removeClass('loading');        
    }

    function closeModal(e) {
        e.preventDefault();

        successWrap.addClass('hidden');
    }



}();